/**
 * Shared MUI style objects for the tournament creation wizard steps.
 * Used in StepNormalRoundsMatches and StepTeamRoundsMatches.
 */

export const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 200,
      bgcolor: '#0f172a',
      color: '#cbd5e1',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: 0,
      '& .MuiMenuItem-root': {
        fontSize: '0.85rem',
        padding: '6px 12px',
        '&:hover': {
          bgcolor: 'rgba(255, 255, 255, 0.05)',
        },
        '&.Mui-selected': {
          bgcolor: 'rgba(58, 110, 182, 0.2)',
          '&:hover': {
            bgcolor: 'rgba(58, 110, 182, 0.25)',
          },
        },
      },
    },
  },
};

export const compactInputSx = {
  '& .MuiOutlinedInput-root': {
    height: '34px',
    borderRadius: 0,
    fontSize: '0.85rem',
    '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)' },
    '&:hover fieldset': { borderColor: '#3a6eb6' },
    '&.Mui-focused fieldset': { borderColor: '#3a6eb6' },
  },
  '& .MuiSelect-select': {
    paddingTop: '0px',
    paddingBottom: '0px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiInputBase-input': {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.85rem',
    transform: 'translate(14px, 7px) scale(1)',
    color: '#94a3b8',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -8px) scale(0.75)',
    },
  },
};

export const resultSelectMenuProps = {
  PaperProps: {
    sx: {
      ...selectMenuProps.PaperProps.sx,
      '& .MuiMenuItem-root': {
        ...selectMenuProps.PaperProps.sx['& .MuiMenuItem-root'],
        fontFamily: 'Lucida Console, monospace',
      },
    },
  },
};

export const resultInputSx = {
  ...compactInputSx,
  '& .MuiOutlinedInput-root': {
    ...compactInputSx['& .MuiOutlinedInput-root'],
    fontFamily: 'Lucida Console, monospace',
  },
  '& .MuiSelect-select': {
    ...compactInputSx['& .MuiSelect-select'],
    fontFamily: 'Lucida Console, monospace',
  },
};
